import { render, staticRenderFns } from "./KeyboardCode.vue?vue&type=template&id=2a055480"
import script from "./KeyboardCode.vue?vue&type=script&lang=js"
export * from "./KeyboardCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports